import type {
  InsightExplorerDistributionPayload,
  InsightExplorerDistributionResponse,
  InsightExplorerPayload,
  InsightExplorerTrendResponse,
} from '@/features/InsightExplorer/types/types';
import { timeOut } from '@/utils/util';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';
import {
  getInsightExplorerDistribution,
  getInsightExplorerTrend,
} from './mock';

const mock = false;

const insightExplorerService = {
  getInsightExplorerTrend: async (
    payload: InsightExplorerPayload,
  ): Promise<InsightExplorerTrendResponse> => {
    if (mock) {
      await timeOut(2000);
      return getInsightExplorerTrend(payload);
    }
    const wa = getCurrWorkspaceAlias();
    const response = await defaultAxios.post(
      `/workspaces/${wa}/insight_explorer/trend`,
      payload,
    );
    return response.data;
  },
  getInsightExplorerDistribution: async (
    payload: InsightExplorerDistributionPayload,
  ): Promise<InsightExplorerDistributionResponse> => {
    if (mock) {
      await timeOut(2000);
      return getInsightExplorerDistribution(payload);
    }
    const wa = getCurrWorkspaceAlias();
    const response = await defaultAxios.post(
      `/workspaces/${wa}/insight_explorer/distribution`,
      payload,
    );
    return response.data;
  },
};

export default insightExplorerService;
